// src/hooks/useAuth.js
import { useState, useEffect } from "react";

const isValidToken = (token) => {
  if (!token) return false;
  const parts = token.split(".");
  return parts.length === 3;
};

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(isValidToken(token));
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };

  return { isAuthenticated, loading, logout };
};

export default useAuth;
